import { useEffect } from "react";

export const useBodyScroll = () => {
  useEffect(() => {
    if (typeof document === "undefined") {
      return;
    }
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    document.documentElement.scrollLeft = document.body.scrollLeft = 0;
  }, []);
};
